var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'easyscreen-button-group',
    `easyscreen-button-group_${ _vm.gap }`,
    `easyscreen-button-group_${ _vm.gapSide }`
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }